
/* SETTING */
export const GET_SETTING_LISTING = "GET_SETTING_LISTING";
export const GET_SETTING_LISTING_SUCCESS = "GET_SETTING_LISTING_SUCCESS";
export const GET_SETTING_LISTING_FAIL = "GET_SETTING_LISTING_FAIL";

export const UPDATE_SETTING = "UPDATE_SETTING";
export const UPDATE_SETTING_SUCCESS = "UPDATE_SETTING_SUCCESS";
export const UPDATE_SETTING_FAIL = "UPDATE_SETTING_FAIL";

export const GET_POINT_LISTING = "GET_POINT_LISTING";
export const GET_POINT_LISTING_SUCCESS = "GET_POINT_LISTING_SUCCESS";
export const GET_POINT_LISTING_FAIL = "GET_POINT_LISTING_FAIL";

export const UPDATE_POINT = "UPDATE_POINT";
export const UPDATE_POINT_SUCCESS = "UPDATE_POINT_SUCCESS";
export const UPDATE_POINT_FAIL = "UPDATE_POINT_FAIL";

export const RESET_SETTING_STATE = 'RESET_SETTING_STATE';